import React from 'react';
import { Section } from '../Section';
import { Paragraph, SectionTitle, TitleDescription } from '../Typography';
import { EventsList } from './index';
import { mediaQueries } from 'src/style/breakpoints';
import sizes from 'src/style/sizes';
import { TwoColumns } from '../Section/index';
import Spaceship from '../Illustrations/Spaceship.svg';
import MoonLoader from 'react-spinners/MoonLoader';
import colors from 'src/style/colors';
import { useFutureDataFromMeetup } from 'src/utils/useFutureDataFromMeetup';

/**
 * @type React.FunctionComponent<{ column?: boolean, home?: boolean}>
 */

const EventsSection = React.memo(({ column, home, id, dataFromMeetup }) => {
  const [isLoading, futureDataFromMeetup] = useFutureDataFromMeetup(dataFromMeetup);

  return (
    <Section
      theme="light"
      id={id}
      css={{
        position: 'relative',
        paddingBottom: 150,
        [mediaQueries.phoneOnly]: {
          paddingBottom: 100,
        },
      }}
    >
      {futureDataFromMeetup.length !== 0 ? (
        <>
          <TwoColumns
            sizeLeft={column ? sizes.columnWidth.large : sizes.columnWidth.small}
            left={
              <div>
                <SectionTitle css={{ paddingBottom: 20 }}>
                  Nos prochaines réunions d'information
                </SectionTitle>
                <TitleDescription css={{ fontSize: 21 }}>
                  Venez rencontrer l'équipe du Reacteur
                </TitleDescription>
                <Paragraph css={{ paddingBottom: 0 }}>
                  Parce que nous pensons que le contact humain est important, nous organisons
                  différents événements pour parler code, dans une ambiance détendue et amicale.
                </Paragraph>
                <Paragraph>
                  Pour assister à une réunion d'information, vous devez cliquer sur l'une des dates
                  puis compléter le formulaire (si ça n'est pas déjà fait).
                  {/* Certaines ont lieu dans nos locaux, d'autres en visio-conférence. */}
                </Paragraph>
                {column ? <EventsList dataFromMeetup={dataFromMeetup} /> : ''}
              </div>
            }
            sizeRight={column ? sizes.columnWidth.small : sizes.columnWidth.large}
            right={
              column ? (
                ''
              ) : isLoading ? (
                <div
                  css={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '100%',
                  }}
                >
                  <MoonLoader color={colors.purple} size={20} />
                </div>
              ) : (
                <EventsList dataFromMeetup={futureDataFromMeetup} />
              )
            }
          />
          <div
            css={{
              position: 'absolute',
              display: 'none',
              [mediaQueries.tabletLandscapeUp]: {
                display: 'block',
                width: '36%',
                right: '2vw',
                top: 200,
              },
              [mediaQueries.desktopUp]: {
                right: '10vw',
                width: '30%',
                maxWidth: 480,
                top: 200,
              },
              [mediaQueries.bigDesktopUp]: {
                right: '16vw',
                width: '100%',
                maxWidth: 500,
              },
            }}
          >
            {column ? (
              <img src={Spaceship} alt="illustration satellites" css={{ width: '100%' }} />
            ) : (
              ''
            )}
          </div>
        </>
      ) : null}
    </Section>
  );
});

export default EventsSection;
